import { combineReducers } from 'redux';
import app from './appReducer';
import thread from './threadReducer';

export default combineReducers({
  app,
  thread,
});
